import React, { Component } from 'react';
import { Link } from 'react-router-dom';

class Page_header extends Component {

	render() {

		let HeaderTitle = this.props.headertitle;
		let publicUrl = process.env.PUBLIC_URL + '/';
		let Subheader = this.props.subheader ? this.props.subheader : HeaderTitle;
		let Img = this.props.Img ? this.props.Img : 'header-banner-1-new.jpg';

		return (
			<section
				className="inner-banner go-top"
				style={{
					backgroundImage: `url(${publicUrl}assets/images/backgrounds/${Img})`
				}}
			>
				<div className="inner-banner__overlay"></div>

				{/* Animated Shapes */}
				<div className="inner-banner__circle-1"></div>
				<div className="inner-banner__circle-2"></div>
				<div className="inner-banner__circle-3"></div>

				<div className="container">
					<div className="inner-banner__content">

						<ul className="list-unstyled inner-banner__breadcrumb">
							<li>
								<a href="/">Home</a>
							</li>
							<li>
								<span>{Subheader}</span>
							</li>
						</ul>

						<h1>{HeaderTitle}</h1>

					</div>
				</div>
			</section>
		);
	}
}


export default Page_header